import React from 'react'
import { PreviewBody, PreviewLayout } from '../sub-components/PreviewLayout'
import { RewardsPageType } from 'src/lib/types/uiPreview'
import PreviewRewards from '../sub-components/PreviewRewards'
import LoadingList from '../skeletons/LoadingList'
import LoadingPaymentMethod from '../skeletons/LoadingPaymentMethod'

const RewardsPage: React.FC<RewardsPageType> = config => {
  return (
    <PreviewLayout showTotal={{ isEnabled: true, showStrikeThrough: true }}>
      <PreviewBody>
        <LoadingList
          length={2}
          skeleton={{
            layout: 'row',
            config: [
              { height: 1, width: 1 },
              { height: 1, width: 6 }
            ]
          }}
        />
        <PreviewRewards uiConfig={config} />
        <LoadingPaymentMethod
          length={1}
          skeleton={{
            layout: 'row',
            config: [
              { height: 1, width: 1 },
              { height: 1, width: 6 }
            ]
          }}
        />
      </PreviewBody>
    </PreviewLayout>
  )
}

export default RewardsPage
